import { Megaphone, Calendar } from "lucide-react";

const announcements: { id: number; title: string; body: string; date: string; isNew: boolean }[] = [
  {
    id: 1,
    title: "Welcome to AI StoryCraft Studio 🎉",
    body: "You've made it! Welcome to the community. Here's how to get started:\n\n1. Head to Keyword Research to find what your audience is already searching for\n2. Use Nexis AI to generate your first script in under 60 seconds\n3. Build your first digital product with Monetization AI\n4. Ask Fint anything — your AI mentor is available 24/7\n\nIf you need help at any point, visit the Support page or email us at support@ai-storycraft-studio.com. We're excited to see what you build.",
    date: new Date().toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" }),
    isNew: true,
  },
];

export default function Announcements() {
  return (
    <div className="p-6 md:p-8">
      {/* Header */}
      <div className="flex items-center gap-3 mb-8">
        <div className="w-12 h-12 rounded-xl bg-blue-500/20 flex items-center justify-center">
          <Megaphone className="w-6 h-6 text-blue-400" />
        </div>
        <div>
          <h1 className="font-display text-2xl font-bold">Announcements</h1>
          <p className="text-muted-foreground">Latest updates and news</p>
        </div>
      </div>

      {/* Announcements List */}
      <div className="space-y-4 max-w-3xl">
        {announcements.map((announcement) => (
          <div key={announcement.id} className="glass-card p-6 hover:border-primary/20 transition-colors">
            <div className="flex items-start justify-between gap-4 mb-3">
              <h2 className="font-display text-xl font-semibold text-foreground">
                {announcement.title}
              </h2>
              {announcement.isNew && (
                <span className="px-2 py-0.5 rounded-full bg-primary/20 text-primary text-xs font-medium">
                  NEW
                </span>
              )}
            </div>
            <p className="text-muted-foreground mb-4 leading-relaxed whitespace-pre-line">
              {announcement.body}
            </p>
            <div className="flex items-center gap-2 text-sm text-muted-foreground">
              <Calendar className="w-4 h-4" />
              {announcement.date}
            </div>
          </div>
        ))}

        {announcements.length === 0 && (
          <div className="text-center py-12">
            <Megaphone className="w-12 h-12 text-muted-foreground mx-auto mb-4" />
            <h3 className="font-semibold text-foreground mb-2">No announcements yet</h3>
            <p className="text-muted-foreground">Check back later for updates!</p>
          </div>
        )}
      </div>
    </div>
  );
}
